import actionTypes from '../actionTypes';

export const requestTournaments = () => ({
    type: actionTypes.TOURNAMENTS_REQUEST,
});

export const successTournaments = (list) => ({
    type: actionTypes.TOURNAMENTS_SUCCESS,
    value: list.map(t => t.playerStatus ? t : { ...t, playerStatus: 'notRegistered' }),
});

export function setCasinoTournament( tournament ) {
    return {
        type: actionTypes.SET_TOURNAMENT,
        selected: tournament
    };
}

export const failTournaments = (e) => ({
    type: actionTypes.TOURNAMENTS_FAIL,
    exception: e,
});

export const selectCasinoTournament = (selected) => ({
    type: actionTypes.SELECT_TOURNAMENT,
    selected
});

export const showCasinoTournaments = (show) => ({
    type: actionTypes.TOGGLE_TOURNAMENTS,
    show
});

export const openTourLobby = (tourId) => ({
    type: actionTypes.GET_FINISHED_TOURID,
    tourId
});